document.addEventListener('DOMContentLoaded', function() {


  // Add the new function
  function toggleProductCanvasContainer() {
    const skuElement = document.querySelector('.product-meta__sku-number');
    const productCanvasContainer = document.getElementById('productCanvasContainer');
    const paymentContainer = document.querySelector('.product-form__payment-container');
    const submitEnquiry = document.getElementById('submit-enquiry'); // Assuming this element has the id 'submit-enquiry'
    const pdp__priceList_Canvas = document.querySelector('.pdp__priceList');

    if (skuElement && productCanvasContainer && paymentContainer && submitEnquiry) {
      const skuText = skuElement.textContent || skuElement.innerText;
  
      // Check if the skuElement has the class 'non-purchasable'
      const isNonPurchasable = skuElement.classList.contains('non-purchasable');
  
      if (isNonPurchasable && skuText.startsWith('custom-')) {
        productCanvasContainer.style.display = 'block';
        paymentContainer.style.display = 'none';
        pdp__priceList_Canvas.style.display = 'none';
      } else if (isNonPurchasable && !skuText.startsWith('custom-')) {
        productCanvasContainer.style.display = 'none';
        paymentContainer.style.display = 'flex';
        pdp__priceList_Canvas.style.display = 'flex';
      } else {
        productCanvasContainer.style.display = 'block';
        pdp__priceList_Canvas.style.display = 'none';
        submitEnquiry.style.display = 'none';
      }
    }
  }


  // Optionally, run the function immediately upon page load
  toggleProductCanvasContainer();

   const skuElement = document.querySelector('.product-meta__sku-number');
  if (skuElement) {
    document.addEventListener('variant:changed', function() {
      toggleProductCanvasContainer();
    });
  }

  
  let originalBackgroundUrl = null;
  const canvas = document.getElementById('productCanvas');
  const ctx = canvas.getContext('2d');
  const previewButton = document.getElementById('preview-image');
  
  const querySelector = (selector) => document.querySelector(selector);

  const setAttributes = (el, attrs) => {
    for (let key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
  };
  
  
  function getSelectedPlacements() {
    const selectedPlacements = [];
    const allPlacements = document.querySelectorAll('.placement-option');
    allPlacements.forEach((placement) => {
      const radioYes = placement.querySelector('input[value="yes"]:checked');
      if (radioYes) {
        selectedPlacements.push(radioYes.name);
      }
    });
    return selectedPlacements;
  }
  
  function collectAndSubmitData() {
    // Get the thumbnail src
    const thumbnailElement = document.querySelector('.uploadkit-thumbnail');
    const thumbnailSrc = thumbnailElement ? thumbnailElement.src : 'No thumbnail';

    // Get selected placements
    const selectedPlacements = getSelectedPlacements();

    // Construct email body
let emailBody = `\n\n\nPlease do not delete: \n\nSelected Placements: ${selectedPlacements.join(", ")} \nLogo URL: ${thumbnailSrc}`;
    
    // Encode newlines and spaces
    emailBody = encodeURIComponent(emailBody);

  // Get the product title from the data attribute
  const productTitle = document.getElementById('submit-enquiry').getAttribute('data-product-title');

  // Update the mailto link
    
  const submitEnquiryElement = document.getElementById('submit-enquiry');
  submitEnquiryElement.href = `mailto:sales@leachs.com?subject=Custom Enquiry request: ${encodeURIComponent(productTitle)}&body=${emailBody}`;
  submitEnquiryElement.style.display = 'inline-block';
  }
  
  function buildLogoBounds() {
    return horizontal.map((_, i) => ({
      x: parseFloat(horizontal[i]),
      y: parseFloat(vertical[i]),
      width: parseFloat(p_width[i]),
      height: parseFloat(p_height[i])
    }));
  }

  function setCanvasDimensions(scaffoldImage) {
    canvas.width = scaffoldImage.width;
    canvas.height = scaffoldImage.height;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  function replaceGalleryImage(dataURL) {
    const galleryImageElement = querySelector('.logo-background-image');
    setAttributes(galleryImageElement, { src: dataURL, "data-src": dataURL});

    const anchorElement = querySelector('.logo-background a');
    if (anchorElement) {
      anchorElement.setAttribute("data-src", dataURL);
    }
  }
  
  let hasCanvasBeenDrawn = false; // Add this flag

  function startDrawingCanvas(logoSrc) {
    if (hasCanvasBeenDrawn) {
      return;
    }
    
    let logoBounds = buildLogoBounds();
    const selectedPlacements = getSelectedPlacements();

    if (selectedPlacements.length > 0) {
      logoBounds = logoBounds.filter((bound, index) => {
        const rowIndex = selectedPlacements.map(row => parseInt(row.split(' ')[1]) - 1); // Subtracting 1 because array indices start from 0
        return rowIndex.includes(index);
      });
    }

    if (originalBackgroundUrl === null) {
        const backgroundElement = document.querySelector('.logo-background-image');
        originalBackgroundUrl = backgroundElement ? backgroundElement.getAttribute('data-zoom') : '';
    }

    function drawImageWithinBounds(ctx, image, x, y, width, height, boundWidth, boundHeight, repeatValue, spacingValue) {
      let aspectRatio = width / height;
      let boundAspectRatio = boundWidth / boundHeight;
      let newWidth, newHeight;
    
      // If the logo is repeating, make it smaller based on spacing
      if (repeatValue > 1) {
        let totalWidth = (boundWidth + spacingValue) * repeatValue - spacingValue;
        boundWidth = (totalWidth / repeatValue) - spacingValue;
        boundAspectRatio = boundWidth / boundHeight;
      }
    
      if (aspectRatio > boundAspectRatio) {
        newWidth = boundWidth;
        newHeight = newWidth / aspectRatio;
      } else {
        newHeight = boundHeight;
        newWidth = newHeight * aspectRatio;
      }
    
      const centerX = x + (boundWidth - newWidth) / 2;
      const centerY = y + (boundHeight - newHeight) / 2;
    
      ctx.drawImage(image, centerX, centerY, newWidth, newHeight);
    }


    const replaceGalleryImage = () => {
      const dataURL = canvas.toDataURL("image/png");
      const galleryImageElement = document.querySelector('.logo-background-image');
      galleryImageElement.src = dataURL;
      galleryImageElement.setAttribute("data-src", dataURL);
      galleryImageElement.setAttribute("data-zoom", dataURL);
      galleryImageElement.setAttribute("data-srcset", dataURL);
      galleryImageElement.setAttribute("srcset", dataURL);

      const anchorElement = document.querySelector('.logo-background a');
      if (anchorElement) {
        anchorElement.setAttribute("data-src", dataURL);
      }
    };

    const drawProductAndLogos = (logoImage, backgroundUrl) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const scaffoldImage = new Image();
      scaffoldImage.crossOrigin = "Anonymous";
      scaffoldImage.src = backgroundUrl;
      scaffoldImage.onload = () => {
        // Set the canvas dimensions to match the original size of the background image
        canvas.width = scaffoldImage.width;
        canvas.height = scaffoldImage.height;
    
        // Draw the background image at its original size
        ctx.drawImage(scaffoldImage, 0, 0, scaffoldImage.width, scaffoldImage.height);
    
      for (let i = 0; i < logoBounds.length; i++) {
        let bound = logoBounds[i];
        let spacingValue = parseFloat(spacing[i] || 0);
        let repeatValue = parseInt(repeatCount[i] || 1);
      
        let x = bound.x;
        for (let j = 0; j < repeatValue; j++) {
          drawImageWithinBounds(ctx, logoImage, x, bound.y, logoImage.width, logoImage.height, bound.width, bound.height, repeatValue, spacingValue);
          x += (bound.width + spacingValue); // Use parseFloat to allow decimals
        }
      }
        hasCanvasBeenDrawn = true;
        replaceGalleryImage();
      };
      const skuElement = document.querySelector('.product-meta__sku-number');
      const isNonPurchasable = skuElement ? skuElement.classList.contains('non-purchasable') : false;
      
      if (isNonPurchasable) {
        document.getElementById('submit-enquiry').style.display = 'inline-block';
      }
    };

    const backgroundElement = document.querySelector('.logo-background-image');
    const backgroundUrl = backgroundElement ? backgroundElement.getAttribute('data-zoom') : '';

    const logoImage = new Image();
    logoImage.crossOrigin = "Anonymous";
    logoImage.src = logoSrc;
    logoImage.onload = () => {
      drawProductAndLogos(logoImage, originalBackgroundUrl); // Use originalBackgroundUrl here
      logoImage.onload = null;
    };
  }
if (previewButton) {
  let isFirstClick = true;
  previewButton.addEventListener('click', function() {
    hasCanvasBeenDrawn = false;
    const selectedPlacements = getSelectedPlacements();
    const placementErrorElement = document.getElementById('placement-error');
    const imageErrorElement = document.getElementById('image-error');

    document.getElementById('submit-enquiry').addEventListener('click', collectAndSubmitData);

    const isPlacementElementPresent = !!document.querySelector('#logoPlacementSelection'); // Check if the placement selection element exists

    if (isPlacementElementPresent && selectedPlacements.length === 0) {
      // Show the placement error element only if placement selection element is present and no placement option is selected
      if (placementErrorElement) {
        placementErrorElement.style.display = 'block';
      }
      return; // Skip further execution if no placement option is selected
    } else {
      // Hide the placement error element if placements are selected
      if (placementErrorElement) {
        placementErrorElement.style.display = 'none';
      }
    }

    const thumbnail = querySelector('.uploadkit-thumbnail');
    if (thumbnail) {
      startDrawingCanvas(thumbnail.src);

      const logoThumbnailBackground = querySelector('.logo-thumbnail-background');
      if (logoThumbnailBackground) {
        logoThumbnailBackground.click();
      }
      // Hide the image error element if image exists
      if (imageErrorElement) {
        imageErrorElement.style.display = 'none';
      }
      window.scrollTo(0, 0);
    } else {
      // Show the image error element if no image exists
      if (imageErrorElement) {
        imageErrorElement.style.display = 'block';
      }
    }
        if (isFirstClick) {
      previewButton.innerText = 'Update Preview'; // or use textContent, both are similar
      isFirstClick = false; // update the variable so this block doesn't run again
    }
  });
}

});